import { useIntl } from 'react-intl';
import { useCallback } from 'react';

import { useSnackbar } from '@ocx-app/lib/snackbar/snackbar';

import { messages } from './signup.messages';
import { SMS_ATTEMPT_TIMEOUT_SECONDS } from './signup.constants';

export const useShowAttemptTimeoutMessage = () => {
  const intl = useIntl();
  const snackbar = useSnackbar();

  return useCallback(
    () =>
      snackbar.open(
        intl.formatMessage(messages['signup:sms-attempt-timeout:message'], { seconds: SMS_ATTEMPT_TIMEOUT_SECONDS }),
        { variant: 'warning' },
      ),
    [intl, snackbar],
  );
};
